export default function DrYasir() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#F5F5F0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative w-full h-[600px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/5c4bc2408a886f100621cea1fe888413.jpeg"
                alt="Dr. Yasir Saeed - Principal Dentist"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-6">
              IMPLANT CARE LED BY<br /><strong>DR. YASIR SAEED</strong><br />(Principal Dentist)
            </h2>
            <p className="text-base text-[#7A8178] mb-8">
              Your implant journey is led by Dr. Yasir Saeed, with over 30 years of experience, known for:
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-tooth-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-2">Years of Experience</h3>
                  <p className="text-base text-[#7A8178]">
                    Over 30 years of experience in implant dentistry with hundreds of successful cases.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-settings-3-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-2">Precise Surgical Skills</h3>
                  <p className="text-base text-[#7A8178]">
                    Precise, minimally invasive surgical skills for faster healing and better outcomes.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-2">Outstanding Chairside Manner</h3>
                  <p className="text-base text-[#7A8178]">
                    Outstanding chairside manner with nervous patients, making them feel comfortable and at ease.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-line-chart-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42] mb-2">Natural-Looking Results</h3>
                  <p className="text-base text-[#7A8178]">
                    Consistently delivering natural-looking, long-lasting results that exceed expectations.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-[#D0A24F]/10 p-6 rounded-2xl border-l-4 border-[#D0A24F]">
              <p className="text-base text-[#444c42] leading-relaxed mb-4">
                Dr. Saeed combines advanced technology, meticulous planning, and a personalised approach to ensure every patient receives safe, comfortable, and predictable implant treatment.
              </p>
              <p className="text-base text-[#444c42] leading-relaxed font-semibold">
                Dr. Yasir Saeed is known for his gentle approach and exceptional care with nervous and trauma-experienced patients.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
